
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"4","y":"8","width":"15","height":"9"}},[_c('path',{attrs:{"d":"M5.577 11.479l5.05 4.512c.76.679 1.989.679 2.749 0l5.05-4.512c1.228-1.098.35-2.979-1.384-2.979h-10.1c-1.735 0-2.593 1.881-1.365 2.979z","fill":"#000"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M-.001.5h24v24h-24V.5z","fill":"#858C94"}})])])
          )
        }
      }
    